import React from 'react';
import MuiAutocomplete, { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';
import { Paper } from '@mui/material';

import { AutocompleteOption, AutocompleteProps } from '@occc-app/design-system';

// Custom renderOption is needed because by default key is label, not value. Label can be repeated.
const renderOption = (props: React.HTMLAttributes<HTMLLIElement>, option: AutocompleteOption) => (
  <li {...props} key={option.value}>
    {option.label}
  </li>
);

export const Autocomplete: React.FC<AutocompleteProps> = ({
  inputProps,
  renderInput,
  chipPropsIcon: Icon,
  ...props
}) => {
  const renderInputComponent = React.useCallback(
    (params: AutocompleteRenderInputParams) => renderInput(params, inputProps),
    [inputProps, renderInput],
  );
  const getOptionLabel = (option: any) => option.label;

  return (
    <MuiAutocomplete
      renderInput={renderInputComponent}
      getOptionLabel={getOptionLabel}
      autoHighlight={true}
      ChipProps={{
        variant: 'outlined',
        color: 'primary',
        icon: Icon ? <Icon /> : undefined,
      }}
      PaperComponent={(props) => <Paper {...props} elevation={1} />}
      sx={{
        '& input': {
          backgroundColor: 'inherit', // One-off: Prevents default gray background when parent component is in 'disabled' status
        },
      }}
      renderOption={renderOption}
      {...props}
    />
  );
};
